import { post } from "../../services/HttpService";

export class RecLimitedApiService {
    static validations = {};

    static generateApplicationId = (queryData = {}, config = {}) => {
        return post(
            `api/v1/rec_limited/generate-application-id/`,
            queryData,
            config
        ).catch((error) => ({
            success: false,
            data: error?.response?.data ?? {},
            status: error?.response?.status ?? 400,
        }));
    };

    static initiatePayment = (queryData = {}, config = {}) => {
        return post(
            `api/v1/rec_limited/initiate/`,
            queryData,
            config
        ).catch((error) => ({
            success: false,
            data: error?.response?.data ?? {},
            status: error?.response?.status ?? 400,
        }));
    };

    static downloadReceipt = (queryData = {}, config = {}) => {
    return post(
        "api/v1/rec_limited/download-receipt/",
        queryData,
        config
    );
};

    static resendOtp = (queryData = {}, config = {}) => {
        return post(
            `api/v1/rec_limited/resend-otp/`,
            queryData,
            config
        ).catch((error) => ({
            success: false,
            data: error?.response?.data ?? {},
            status: error?.response?.status ?? 400,
        }));
    };

    static verifyOtp = (queryData = {}, config = {}) => {
        return post(
            `api/v1/rec_limited/verify-otp/`,
            queryData,
            config
        ).catch((error) => ({
            success: false,
            data: error?.response?.data ?? {},
            status: error?.response?.status ?? 400,
        }));
    };

    static sendOtp = (queryData = {}, config = {}) => {
        return post(
            `api/v1/rec_limited/send-otp/`,
            queryData,
            config
        ).catch((error) => ({
            success: false,
            data: error?.response?.data ?? {},
            status: error?.response?.status ?? 400,
        }));
    };

    static getTransactions = (queryData = {}, config = {}) => {
        return post(
            `api/v1/rec_limited/get-transactions/`,
            queryData,
            config
        ).catch((error) => ({
            success: false,
            data: error?.response?.data ?? {},
            status: error?.response?.status ?? 400,
        }));
    };
}